import { render, staticRenderFns } from "./clientNote.vue?vue&type=template&id=22ebeabe&scoped=true&"
import script from "./clientNote.vue?vue&type=script&lang=js&"
export * from "./clientNote.vue?vue&type=script&lang=js&"
import style0 from "./clientNote.vue?vue&type=style&index=0&id=22ebeabe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ebeabe",
  null
  
)

export default component.exports